import { paymentAppleSession } from '@shory-health-individual/customer-api';
import { useAppPlatformContextOptions } from '../../../contexts/app';

const useApplePayment = () => {
	const { apiConnectionOptions } = useAppPlatformContextOptions();

	const getApplePaySession = async (sessionUrl: string) => {
		const response = await paymentAppleSession(apiConnectionOptions)({
			sessionUrl,
		});

		return response;
	};

	return {
		getApplePaySession,
	};
};

export default useApplePayment;
